module.exports = __webpack_public_path__ + "static/media/blackboard-selector.958abadd.svg";